import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "customer-reviews" }
const _hoisted_2 = { class: "customer-reviews__list" }
const _hoisted_3 = { class: "pager" }

import { computed, onMounted, ref } from 'vue';
import * as hotelReviewsService from '@services/hotelReviewsService';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import ReviewBox from '@lmt-rpb/ReviewBox/ReviewBox.vue';
import CustomerReviewsHeader from './internals/CustomerReviewsHeader.vue';
import type { AggregateRatingType, CustomerReviewType, ReviewType } from '@/interfaces/review-types';
import { logErrorResponse } from '@/js/utils/utils';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	iffCode: number;
	hotelName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviews',
  props: {
    iffCode: {},
    hotelName: {}
  },
  emits: ['no-reviews'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const { isMinTablet } = storeToRefs(useBreakpointStore());
const reviewsPerPage = computed((): number => (isMinTablet.value ? 4 : 3));
const aggregatedRating = ref<AggregateRatingType | null>(null);
const customerReviews = ref<ReviewType[]>([]);
const nextUrl = ref<string>('');
const isLastPage = computed(() => !nextUrl.value);
const isLoading = ref<boolean>(true);
const showFetchMoreButton = computed((): boolean => !isLoading.value && !!customerReviews.value.length && !isLastPage.value);

async function fetchInitial() {
	const resp = await fetchItems();

	if (resp?.AggregateRating) {
		// only set aggregatedRating once on initial load
		aggregatedRating.value = resp.AggregateRating;
	}

	if (resp) {
		assignResponseValues(resp);
	}

	if (!(aggregatedRating.value && customerReviews.value.length)) {
		emit('no-reviews', true);
	}
}

const loadMoreAnalytics = () => {
	SelectContentAnalytics.selectContent({ cId: 'reviews_button', cType: 'ux_hotelpage_load_more' });
};

async function fetchMore() {
	loadMoreAnalytics();
	const resp = await fetchItems();
	if (resp) {
		assignResponseValues(resp);
	}
}

function assignResponseValues(resp: CustomerReviewType) {
	customerReviews.value.push(...resp.CustomerReviews);
	nextUrl.value = resp?._links?.next ?? '';
}

async function fetchItems() {
	isLoading.value = true;
	let resp: CustomerReviewType | null = null;
	try {
		resp = await hotelReviewsService.get(props.iffCode, reviewsPerPage.value, nextUrl.value);
	} catch (error) {
		logErrorResponse('customer reviews request error', error, { params: [props.iffCode, reviewsPerPage.value, nextUrl.value] }, resp);
	} finally {
		isLoading.value = false;
	}

	return resp;
}

const onShowDetailReview = (index: number) => {
	SelectContentAnalytics.selectContent({ cId: 'review_item', index, cType: 'ux_hotelpage_show_details' });
};

onMounted(() => {
	fetchInitial();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (aggregatedRating.value && customerReviews.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "customer-reviews__title" }, "Gästebewertung", -1 /* HOISTED */)),
          _createVNode(CustomerReviewsHeader, {
            class: "customer-reviews__header",
            "aggregated-rating": aggregatedRating.value
          }, null, 8 /* PROPS */, ["aggregated-rating"]),
          _createElementVNode("section", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerReviews.value, (review, index) => {
              return (_openBlock(), _createBlock(ReviewBox, {
                key: review.Title + index,
                class: "customer-reviews__item",
                review: review,
                onShowDetailReview: ($event: any) => (onShowDetailReview(index + 1))
              }, null, 8 /* PROPS */, ["review", "onShowDetailReview"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(Loading, {
            key: 0,
            size: "medium",
            class: "pager__loader"
          }))
        : _createCommentVNode("v-if", true),
      (showFetchMoreButton.value)
        ? (_openBlock(), _createBlock(RoundedButton, {
            key: 1,
            class: "customer-reviews__load-more",
            theme: "outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchMore()))
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Mehr Bewertungen anzeigen ")
            ])),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})